import { PrivateRoutes } from '@routes/enums';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/')({
  component: () => <Navigate to={PrivateRoutes.ADMIN_MEMBERS} />,
});
